import store from '..'

export default {
  getAccount(state) {
    if (state.account) {
      return state.account
    }

    if (localStorage.getItem('vitale-account')) {
      store.commit(
        'Account/setAccount',
        JSON.parse(localStorage.getItem('vitale-account'))
      )
    }

    return state.account
  },

  getLinkedAccounts(state) {
    if (state.accounts && state.accounts.length) {
      return state.accounts
    }

    if (localStorage.getItem('vitale-linked-accounts')) {
      store.commit(
        'Account/setAccounts',
        JSON.parse(localStorage.getItem('vitale-linked-accounts'))
      )
    }

    return state.accounts
  }
}
